export default __webpack_public_path__ + "static/media/TR.69a0293b.svg";